<template>
  <validation-observer
    v-if="shouldQuestionRender && isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="vehicle-signage"
      v-bind="observer"
      :validated="formObserver.validated && observer.failed"
    >
      <form-row
        label="Is the vehicle signwritten?"
        :error="formObserver.validated && observer.failed"
      >
        <template slot="helpText">
          <div class="d-flex align-start">
            <v-icon
              class="mr-4"
              color="primary"
            >
              mdi-credit-card-outline
            </v-icon>
            <p>
              <strong>Price sensitive question</strong><br>
              Some insurance providers may provide a discount if your vehicle is signwritten e.g. lettering or logos etc.
            </p>
          </div>
        </template>
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_vehicle-signage`"
          name="Vehicle Signage"
          rules="required"
        >
          <radio
            v-model="vehicleSignageModel"
            :name="`${stepId}_vehicle-signage`"
            :items="constants.YES_NO"
            :error="failed"
          />
        </validation-provider>
      </form-row>
      <form-row
        v-if="vehicleSignageModel"
        id="vehicle_vehicle-signage"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_vehicle-signage`"
          name="Vehicle Signage"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.vehicleSignage"
            :items="vehicleSignageOptions"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select an option from the list', isMobile)"
            :error-messages="errors"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import { omit } from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-vehicle-signage',
  extends: QuestionBase,
  data () {
    return { fields: ['vehicleSignage'] };
  },
  computed: {
    vehicleSignageModel: {
      get () {
        const { vehicleSignage } = this.stepData;
        if (vehicleSignage === null) return null;
        if (vehicleSignage === 'N') return false;
        return true;
      },
      set (val) {
        this.questionData.vehicleSignage = val ? '' : 'N';
      },
    },
    vehicleSignageOptions () {
      return this.helpers.createOptions({ source: omit(this.constants.VEHICLE_SIGNWRITTENS, ['N']) });
    },
  },
};
</script>
